import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const IntegrationPlaceholder = (props: TIconProps): ReactElement => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="12"
      y="12"
      width="40"
      height="40"
      rx="12"
      fill="hsl(from hsl(var(--primary)) h s 60%)"
    />
    <rect
      x="12"
      y="12"
      width="40"
      height="40"
      rx="12"
      stroke="hsl(from hsl(var(--primary)) h s 48%)"
      strokeWidth="2"
    />
    <circle
      cx="32"
      cy="32"
      r="7"
      fill="hsl(from hsl(var(--primary)) h s 78%)"
    />
    <circle cx="32" cy="6" r="5" fill="hsl(from hsl(var(--primary)) h s 53%)" />
    <circle
      cx="58"
      cy="32"
      r="5"
      fill="hsl(from hsl(var(--primary)) h s 53%)"
    />
    <circle
      cx="32"
      cy="58"
      r="5"
      fill="hsl(from hsl(var(--primary)) h s 53%)"
    />
    <circle cx="6" cy="32" r="5" fill="hsl(from hsl(var(--primary)) h s 53%)" />
    <path
      d="M32 12V22"
      stroke="hsl(from hsl(var(--primary)) h s 53%)"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M42 32H52"
      stroke="hsl(from hsl(var(--primary)) h s 53%)"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M32 42V52"
      stroke="hsl(from hsl(var(--primary)) h s 53%)"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M12 32H22"
      stroke="hsl(from hsl(var(--primary)) h s 53%)"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);
